<ng-container *ngIf="useOverlay; else templatePortalContent"></ng-container>

<ng-template #templatePortalContent>
  <div
    class="aside-menu-root"
    [ngClass]="rootClass"
    [class.overlay]="useOverlay"
    [class.opened]="open && (attached || !useOverlay)"
    [class.left]="isPlacementLeft"
    [class.right]="isPlacementRight"
    [class.smallerWidthOnMobile]="smallerWidthOnMobile"
  >
    <div
      class="aside-content"
      [class.closed]="!open"
      [class.toggleVisible]="showCloseButton"
    >
      <div *ngIf="!open" (click)="toggleOpen()">
        <ng-content select=".closed-content"></ng-content>
      </div>
      <ng-content select=".menu-title" *ngIf="open"></ng-content>
      <ng-content select=".menu-content" *ngIf="open"></ng-content>
      <ng-content select=".menu-footer" *ngIf="open"></ng-content>
    </div>
    <button
      data-e2e="collapse-product-list-btn"
      class="btn btn-white btn-round btn-collapse-toggle"
      (click)="toggleOpen()"
      *ngIf="showCloseButton"
    >
      <fa-icon
        [icon]="['fas', 'angle-left']"
        [class.rotated]="placement === 'left' ? !open : open"
        size="xs"
      ></fa-icon>
    </button>
  </div>
</ng-template>
